import React from "react"
import { LeaderBoard } from "../../models/LeaderBoard"
import { ClassificationTable } from "./ClassificationTable"
import { TopScorerCard } from "./TopScorerCard"

interface IProps{
    readonly leaderboard: LeaderBoard["episode_leaderboard"]
}

export class LeaderBoardDisplay extends React.Component<IProps>{
    render = () => {
        const { leaderboard } = this.props

        return <>
            <h1 className="text-center col-12 mt-2">Top scorer</h1>
            <TopScorerCard list={leaderboard.topScorer} />
            <ClassificationTable list={leaderboard.others} />
        </>
    }
}